<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="detail_dialog" top="7vh" width="1300px" :fullscreen="isExpand"
    :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :append-to-body="true" :close-on-press-escape="false">
    <template slot="title">
      <div class="default-dialog-title-box">
        <span>选择商品</span>
        <span class="icon-box">
          <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
          <i class="el-icon-close" @click="handleClose"></i>
        </span>
      </div>
    </template>
    <div class="content">
      <div class="c_group">
        <query-form size="small" label-width="30px" @search="handleSearch" @reset='handleReset' :defaultCollapsed="false" class="content_block">
          <el-form-item label-width="0px">
            <el-input v-model.trim="form.goodsNameOrAnotherName" clearable placeholder="请输入商品名称/商品别名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model.trim="form.sn" clearable placeholder="请输入商品编码(sku)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model.trim="form.modelOrSimpleSpecsOrStoreSnOrBrandName" clearable placeholder="请输入规格/型号/品牌/原厂备件号"></el-input>
          </el-form-item>
          <el-form-item>
            <ChooseGoodsCategory ref="chooseGoodsCategoryRef" checkStrictly @handleSelect="handleSelectCategory" />
          </el-form-item>
          <el-form-item label-width="0px">
            <el-select v-model="form.medicalFlag" placeholder="请选择是否医疗件" clearable filterable>
              <el-option label="全部" :value="null"></el-option>
              <el-option label="医疗件" :value="true"></el-option>
              <el-option label="非医疗件" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </query-form>
      </div>
      <xz-table
        ref="xzTable"
        :columns="columnList"
        :data="dataList"
        :enableRowSelection="true"
        :scroll="{ x: '100%', y: scrollHeight }"
        rowKey="id"
        selectionType="radio"
        :selectedRowKeys="selectedKeys"
        @change="handleSelectionChange"
        @refresh="handleReset">
        <template slot="imageList" slot-scope="imageList">
          <span v-if="imageList && imageList.length > 0">
            <el-image
              :src="imageList[0].url"
              :preview-src-list="imageList.map(img => img.url)"
              style="width: 32px; height: 32px; margin-right: 5px;"
            />
          </span>
          <span v-else>暂无图片</span>
        </template>
      </xz-table>
      <div class="pagination-wrapper">
        <a-pagination
          :current="page.pageNum"
          :total="total"
          :show-total="total => `共 ${total} 条`"
          show-size-changer
          :pageSizeOptions="['10', '20', '30', '50', '100']"
          show-quick-jumper
          :pageSize.sync="page.pageSize"
          @change="handleNumChange"
          @showSizeChange="handleSizeChange"
        />
      </div>
      <div class="selected-tip">已选择商品</div>
      <xz-table
        ref="xzTableSelected"
        :columns="columnList"
        :data="selectedLists"
        :scroll="{ x: '100%' }"
        rowKey="id">
        <template slot="imageList" slot-scope="imageList">
          <span v-if="imageList && imageList.length > 0">
            <el-image
              :src="imageList[0].url"
              :preview-src-list="imageList.map(img => img.url)"
              style="width: 32px; height: 32px; margin-right: 5px;"
            />
          </span>
          <span v-else>暂无图片</span>
        </template>
      </xz-table>
    </div>
    <div class="dialog-footer" style="padding-top: 10px; text-align: right;">
      <el-button plain @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSure" :disabled="!selectedKeys.length">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { skuPageList } from '@/api/goods';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import ChooseGoodsCategory from '@/views/Goods/components/chooseGoodsCategory.vue';

const COMMON_COLUMNS = [
  {
    title: '商品图片',
    dataIndex: 'imageList',
    key: 'imageList',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'imageList' },
  },
  {
    title: '商品编码(sku)',
    dataIndex: 'sn',
    key: 'sn',
    width: 130,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '商品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    width: 180,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '商品别名',
    dataIndex: 'anotherName',
    key: 'anotherName',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '型号',
    dataIndex: 'model',
    key: 'model',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '规格',
    dataIndex: 'simpleSpecs',
    key: 'simpleSpecs',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '品牌',
    dataIndex: 'brandName',
    key: 'brandName',
    width: 160,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '计量单位',
    dataIndex: 'goodsUnit',
    key: 'goodsUnit',
    width: 100,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '原厂备件号',
    dataIndex: 'storeSn',
    key: 'storeSn',
    width: 120,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
  {
    title: '是否医疗件',
    dataIndex: 'medicalFlag',
    key: 'medicalFlag',
    width: 110,
    ellipsis: true,
    customRender: text => {
      return text === true ? '是' : text === false ? '否' : '--';
    },
  },
  {
    title: '商品分类',
    dataIndex: 'merchantGoodsCategoryName',
    key: 'merchantGoodsCategoryName',
    width: 200,
    ellipsis: true,
    customRender: text => {
      return text && text.length ? text.join('>') : '--';
    },
  },
  {
    title: '产品注册证/备案凭证',
    dataIndex: 'registerCode',
    key: 'registerCode',
    width: 170,
    ellipsis: true,
    customRender: text => {
      return text || '--';
    },
  },
];

export default {
  props: {
    from: {
      type: String,
      default: '',
    },
  },
  components: {
    xzTable,
    ChooseGoodsCategory,
  },
  data () {
    return {
      dialogVisible: false,
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      form: {
        goodsNameOrAnotherName: '',
        sn: '',
        modelOrSimpleSpecsOrStoreSnOrBrandName: '',
        medicalFlag: '',
        merchantGoodsCategoryId: null,
      },
      saleType: null,
      selectedKeys: [],
      selectedLists: [],
      total: 0,
      dataList: [],
      columnList: [
        ...COMMON_COLUMNS,
      ],
      scrollHeight: 260,
      page: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  watch: {
    dialogVisible (v) {
      if (v) {
        this.handleSearch();
      } else {
        this.form = this.$options.data().form;
        this.selectedKeys = this.$options.data().selectedKeys;
        this.selectedLists = this.$options.data().selectedLists;
      }
    },
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.merchantGoodsCategoryId = categoryId;
    },
    handleSelectionChange (keys, rows) {
      this.selectedKeys = keys;
      this.selectedLists = rows || [];
    },
    handleSure () {
      this.$emit('handleSelect', this.selectedLists[0]);
      this.dialogVisible = false;
    },
    handleSizeChange (_, size) {
      this.page.pageSize = size;
      this.queryList();
    },
    handleNumChange (num) {
      this.page.pageNum = num;
      this.queryList();
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.queryList();
    },
    handleSearch () {
      this.page.pageNum = 1;
      this.queryList();
    },
    async queryList () {
      let params = {
        marketEnable: 'NO',
        ...this.form,
        ...this.page,
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'DESC',
        }],
      };
      if (this.from === 'platform') params.platformReleaseStatus = 'NOT';
      if (this.from === 'subscribe') params.subscriptionReleaseStatus = 'NOT';
      const { body } = await skuPageList(params);
      this.total = +body.total || 0;
      this.dataList = body.list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.detail_dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .content {
    padding: 0 10px;

    .c_group {
      position: relative;
      .content_block {
        padding: 10px;
      }
    }

    .selected-tip {
      font-size: 15px;
      font-weight: bold;
      color: #1F2733;
      padding-top: 10px;
    }
  }
}
</style>
